import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloProviderNew } from '@apollo/client';
import { Provider } from 'react-redux';
import { getHourInZone, mapKeysDeep, transformKey } from '@td/utils';
import moment from 'moment-timezone';
import { isNaN, merge, set, isEmpty, map } from 'lodash';
import ProviderReferral from '@td/provider_referral';
import { renderReschedule } from '@td/rav_flow';
import { Messaging, BrowserNotifications } from '@teladoc/inbox';
import { PreferencePage } from './preference-page';
import axios from 'axios';

import { TicketAssignment, RelatedTicketsWarningIcon} from './workflow-queue';
import { ServiceLine } from './nurse-queue';
import ProviderBasicSearchIndex from './provider-basic-search';
import Benefits from 'medication_service_ui/dist/benefits';
import { actions as settingsActions } from 'medication_service_ui/dist/settings';
import ProviderCoverageTable from './provider-coverage/provider_coverage_table';
import { advisoryPrescriptionAdminPath } from './config/paths';
import getClientInstance from './config/apollo-client';
import { default as ProviderSearchForm } from './provider-search';
import { ProviderMatchingCriteria } from './provider-matching-criteria';
import ProviderIncentiveCost from './provider-incentive/provider-incentive-cost';
import ProviderSurgeIncentive from './provider-incentive/provider-surge-incentive';
import { Inbox } from './inbox';
import VideoContainer from './Video/components/video-container';
import VideoTestContainer from '@td/video_test';
import { RulesRouting } from './routing-rules';

import { featureActive, fetchSameOrigin } from './Utils';

import { PracticeTeamSearch, PracticeTeamShow, PracticeTeamNew, PracticeTeamEdit } from './practice-team';

import { gql } from '@apollo/client';

import {
  CalloutBox,
  Ticket,
  MemberProfileObject,
  Api,
  BillingForm,
  MemberSupportContext,
  Nav,
  Search,
  Breadcrumb,
  Panel,
  MemberProfile,
  instrumentAction,
  CareCoordinationHub as BaseCareCoordinationHub
} from '@td/membersupport';

import { I18n, translate } from '@td/shared_utils';

import { initNotifications } from '@td/browser_notify';

import {
  PrimaryCareSummaryButton,
  ElationIdRow,
  LaunchElationEhrButton,
  LaunchHistoricalEhrButton,
  LaunchSunriseEhrButton,
  CCDAViewer,
  fetchEmrPatientInitialData,
  fetchEmrPatientDataStart,
  fetchEmrPatientAllergiesInitialData,
  fetchEmrPatientMedicationsInitialData,
  fetchSunrisePatientLinkStart,
  ElationVisitNotes,
  ElationTableOfMedications,
  ElationTableOfAllergies,
  AllscriptVisitNotes,
  fetchEmrPatientMirthMedicationsInitialData,
  fetchEmrPatientMirthAllergiesInitialData,
  AllscriptTableOfMedications,
  AllscriptTableOfAllergies,
  AllscriptClinicalIntakeNotes,
  AllscriptIdRowForWaitingRoom,
  AllscriptIdRowForMemberAccount
} from '@td/emr';

import { CarePlanNew, CarePlanEdit, CarePlanShow } from '@td/care_plan';
import PanelsContainer from "./panels";

import ConsultQueuePagerContainer from './consult-queue/components/consult-queue-pager-container';
import ProvidersSchedule from '@td/providers_schedule';
import ConsultQueueFiltersContainer from './consult-queue/components/consult-queue-filters-container';
import { EditSamlConfig } from './saml-config/edit-saml-config';
import PatientConsentForMedicalRecordsExchange from './PatientConsentForMedicalRecordsExchange';
import SendMhdAndPcaToSunriseEhr from './SendMhdAndPcaToSunriseEhr';
import GrantRevokeEmrManagerRole from './GrantRevokeEmrManagerRole';
import { fetchGrantRevokeEmrManagerRoleButtonsStart } from './GrantRevokeEmrManagerRole/redux/actions';
import { CCMClientSettingsContainer } from './ccm-client-settings/CCMClientSettingsContainer';

import {
  MedicationHistory,
  fetchQuickRxByProvider,
  ProviderOrder,
  notificationListener,
  ClinicalAllergy,
  CanadaPharmacyContainer,
  CanadaProviderOrderContainer,
  CanadaProviderOrderHistory,
  CanadaPrescriptionContainer,
  CanadaPrescriptionBuilder,
  HistoryProviderOrder,
  CompletedConsultationProviderOrder,
  ReviewMedicationModal
} from 'medication_service_ui';

import './toastr';

import { RteTestComponent } from './RteTestComponent';
import PayerSelect from './RteTestComponent/components/PayerSelect';
import ClinicalMedication from './clinical-medication';
import PrescriptionModal from './prescription/components/prescription-modal';
import EditPayer from './EditPayer/components/EditPayer';
import Recordings from './recordings';
import { LabOrderHistoryModal } from './lab-order-history';
import { NurseNotes } from './consultation';
import EgrIndex from './external_group_relations/containers/EgrIndex';
import MultiContractOrgRelationsIndex from './multi_contract_org_relations/containers/MultiContractOrgRelationsIndex';
import SurescriptsInformationContainer from './surescripts-information';
import MedicationFormulariesSearch from './medication-formularies/components/search';
import MedicationFormulariesDetails from './medication-formularies/components/details';
import SkuCalculator from './sku-calculator';
import ClinicalReferralsIndex from './clinical-referrals/components/ClinicalReferralsIndex';

import CareTeamTasks from './care-team-tasks';

import { GroupRule } from './rule-to-group';

import 'medication_service_ui/dist/med-service-ui.css';
import 'medication_service_ui/dist/benefits.css';
import EHR from 'app/ehr';
import { EhrFileUploadsContainer } from './FileUploads/components/ehr-file-uploads-container';
import { ProviderSignatureFileUploadsContainer } from './FileUploads/components/provider-signature-file-uploads-container';
import store from './lib/store';

// TODO move these to our react-datepicker fork
import '../../vendor/dependencies/js_libs/rav_flow/src/date-time-picker/styles/react-datepicker.scss';
import '../../vendor/dependencies/js_libs/rav_flow/src/date-time-picker/styles/overrides.scss';
import '../styles/global/global.scss';
import '../../node_modules/conference-react/dist/components/icons/PictureInPicture/picture-in-picture.css';

import {
  loadProfile,
  fetchGroups,
  findMembers,
  performRteCheck,
  openProfile,
  requestAVisit,
  visitResetPassword,
  updateBillingInformation,
  launchSecurePay,
  updateMhd,
  openReg,
  resetPassword,
  unlockAccount,
  escalateMember,
  impersonate,
  fetchPayers,
  memberProfilePath,
  issueDiscount,
  issueFreeConsultation,
  viewVisits,
  terminateBenefit,
  deleteOffer,
  cancelAccount,
  reactivateAccount,
  openReferrals,
  downloadCCR,
  requestCCR,
  addDependent,
  authorizeExcuseNote,
  createNote,
  openInvoiceHistory,
  problemPatient,
  sendMessage,
  draftCarePlan,
  deleteCarePlan,
  editCarePlan,
  createCarePlan,
  disassociateProvider,
  acceptCareRecipient,
  addCareRecipient,
  rejectCareRecipient,
  deleteCareRecipient,
  addCaregiver,
  deleteCaregiver,
  openGroup,
  canDisplayInitiateReferralButton,
  fetchSpecialtiesForInitiateReferral,
  fetchDataForRecentConsultationsTable,
  getInternalReferrals,
  getHealthSignals,
  sendReferral,
  getLabVendors,
  createPreferredLabVendor,
  getVendorPoints,
  openConsultation,
  openInvoicePdf,
  editPrimaryInsuranceInfo,
  editSecondaryInsuranceInfo,
  getRtePayers,
  renderVisitsPage,
  queueLinkBenefits,
  validateLinkBenefits,
  benefitStatusManager,
  validateQuarantineAction,
} from './operations';
import NotificationPreferences from '@td/notification_preferences';

import AutoDialerInitializer from './auto-dialer';
import { authToken } from '@td/api';

import initializePdfJs from './emr/utils/initializePdfJs';
import InsuranceNetworkContainer from './insurance-network/insurance-network-container';
import SameDayVisits from './same-day-visits/SameDayVisits';
import VendorSolutionSetting from './vendor-point-solutions/components/entity-setting'
import VendorSolutionTool from './vendor-point-solutions/components/tools';
import SupervisingPhysicians from './NpCoordination';

import PhysicianSupervisionRules from './states-services/physician-supervision-rules'

initializePdfJs();

const {
  updatePharmacyParams,
  updateMemberParams,
  updateProviderParams,
  updateConsultationParams,
  updateDrugSearchAvailability,
  updatePatientSyncStatus,
  updateQuickRxParams
} = settingsActions;

const CareCoordinationHub = ({ outbound_ssos, sharepoint_links, member_id }) => {
  const [profile, setProfile] = React.useState(undefined);

  React.useEffect(() => {
    fetchSameOrigin(`/members/${member_id}.json?care_coordination_hub`)
      .then(resp => resp.json())
      .then(setProfile);
  }, []);

  const transformedSsos = outbound_ssos.map(s => {
    return {
      // prevent double utf8 encoding: ® displaying as â®
      title: decodeURIComponent(escape(s.asset_title)),
      id: s.entity_asset_id
    };
  });
  const transformedRefUrls = sharepoint_links.map(s => {
    return {
      title: decodeURIComponent(escape(s.asset_title)),
      id: s.entity_asset_id,
      url: s.data.location
    };
  });
  if (!!profile) {
    return <BaseCareCoordinationHub profile={profile} ssoEntityAssets={transformedSsos} refUrls={transformedRefUrls} />;
  } else {
    return <p>Loading Care Coordination Hub</p>;
  }
};

window.reactComponents = {
  Panel,
  MemberProfile,
  Search,
  CareCoordinationHub,
  PhysicianSupervisionRules
};

moment.locale(document.querySelector('html').getAttribute('lang'));
window.moment = moment;
window.td = window.td || {};
window.td.utils = window.td.utils || merge({}, window.td.utils, { getHourInZone });
window.td.globals = window.td.globals || {};
window.td.store = store;

const sharedClientInstance = getClientInstance();

const render = (ComponentClass, renderTarget, props) => {
  const client = getClientInstance();
  if ($(renderTarget).length !== 0) {
    ReactDOM.render(
      <Provider store={store}>
        <ApolloProviderNew client={sharedClientInstance}>
          <ComponentClass {...props} />
        </ApolloProviderNew>
      </Provider>,
      document.querySelector(renderTarget)
    );
    $(renderTarget).addClass('react');
  } else if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`\nUnable to find dom ${renderTarget} element on the page\n`);
    /* eslint-enable */
  }
};

$(() => {
  // Sets up outside integration into the app
  if (window) {
    window.dispatch = store.dispatch;

    const exposedComponentClasses = {
      PayerSelect,
      ElationIdRow,
      AllscriptIdRowForWaitingRoom,
      AllscriptIdRowForMemberAccount
    };
    window.renderReactComponent = (componentName, renderTarget, props) => {
      const componentClass = exposedComponentClasses[componentName];
      render(componentClass, renderTarget, props);
    };
  }

  const elationEhrButtons = document.querySelectorAll('#elation-ehr-button, #button-elation-ehr');

  elationEhrButtons.forEach(button => {
    const memberId = parseInt(button.dataset.memberId);

    render(LaunchElationEhrButton, `#${button.id}`, { memberId });
  });

  const sunriseEhrButtons = document.querySelectorAll('#sunrise-ehr-button, #button-sunrise-ehr');

  sunriseEhrButtons.forEach(button => {
    const memberId = parseInt(button.dataset.memberId);

    render(LaunchSunriseEhrButton, `#${button.id}`, { memberId });

    store.dispatch(fetchSunrisePatientLinkStart({ memberId }));
  });

  const emrManagerRoleTrigger = document.querySelector('#trigger_emr_manager_role_redux_action');

  if (emrManagerRoleTrigger) {
    const currentAdminId = parseInt(emrManagerRoleTrigger.dataset.currentUserId);
    const adminIdsString = emrManagerRoleTrigger.dataset.adminIds;

    if (isNaN(currentAdminId)) return;
    if (isEmpty(adminIdsString) || adminIdsString == '/') return;

    const adminIds = map(adminIdsString.split(','), Number);

    store.dispatch(fetchGrantRevokeEmrManagerRoleButtonsStart({ currentAdminId, adminIds }));
  }

  const grantRevokeEmrMangerRoleButtons = document.querySelectorAll('.grant_revoke_emr_manager_role_buttons');

  $(grantRevokeEmrMangerRoleButtons).each((_index, button) => {
    const adminId = parseInt($(button).data('adminId'));

    ReactDOM.render(
      <Provider store={store}>
        <ApolloProviderNew client={getClientInstance()}>
          <GrantRevokeEmrManagerRole adminId={adminId} />
        </ApolloProviderNew>
      </Provider>,
      button
    );
  });

  const buttonHistoricalElationEhr = document.querySelector('#button-historical-elation-ehr');
  if (buttonHistoricalElationEhr) {
    const memberId = parseInt(buttonHistoricalElationEhr.dataset.memberId);

    render(LaunchHistoricalEhrButton, '#button-historical-elation-ehr', { memberId });
  }

  const elationVisitNotes = document.querySelector('#elation_visit_notes');
  if (elationVisitNotes) {
    const consultationId = parseInt(elationVisitNotes.dataset.consultationId);

    render(ElationVisitNotes, '#elation_visit_notes', { consultationId });
  }

  const allscriptVisitNotes = document.querySelector('#allscript_visit_notes');
  if (allscriptVisitNotes) {
    const consultationId = parseInt(allscriptVisitNotes.dataset.consultationId);

    if (window.allscript_api_enabled_active) {
      render(AllscriptVisitNotes, '#allscript_visit_notes', { consultationId });
    }
  }

  const allscriptIntakeNotes = document.querySelector('#allscript_clinical_intake_notes');
  if (allscriptIntakeNotes) {
    const consultationId = parseInt(allscriptIntakeNotes.dataset.consultationId);

    render(AllscriptClinicalIntakeNotes, '#allscript_clinical_intake_notes', { consultationId });
  }

  const elationTableOfMedications = document.querySelector('#elation_table_of_medications');
  if (elationTableOfMedications) {
    const memberId = parseInt(elationTableOfMedications.dataset.memberId);

    render(ElationTableOfMedications, '#elation_table_of_medications', { memberId });
    const dispatchfetchEmrPatientMedicationsInitialData = () => {
      store.dispatch(fetchEmrPatientMedicationsInitialData({ memberId }));
    };
    set(
      window,
      'td.emr.components.admin.fetchEmrPatientMedicationsInitialData',
      dispatchfetchEmrPatientMedicationsInitialData
    );
  }

  const allscriptTableOfMedications = document.querySelector('#allscript_table_of_medications');
  if (allscriptTableOfMedications) {
    const memberId = parseInt(allscriptTableOfMedications.dataset.memberId);
    render(AllscriptTableOfMedications, '#allscript_table_of_medications', { memberId });
    const dispatchfetchEmrPatientMirthMedicationsInitialData = () => {
      store.dispatch(fetchEmrPatientMirthMedicationsInitialData({ memberId }));
    };
    set(
      window,
      'td.emr.components.admin.fetchEmrPatientMirthMedicationsInitialData',
      dispatchfetchEmrPatientMirthMedicationsInitialData
    );
  }

  const elationTableOfAllergies = document.querySelector('#elation_table_of_allergies');
  if (elationTableOfAllergies) {
    const memberId = parseInt(elationTableOfAllergies.dataset.memberId);
    render(ElationTableOfAllergies, '#elation_table_of_allergies', { memberId });

    const dispatchFetchEmrPatientAllergiesInitialData = () => {
      store.dispatch(fetchEmrPatientAllergiesInitialData({ memberId }));
    };

    set(
      window,
      'td.emr.components.admin.fetchEmrPatientAllergiesInitialData',
      dispatchFetchEmrPatientAllergiesInitialData
    );
  }

  const allscriptTableOfAllergies = document.querySelector('#allscript_table_of_allergies');
  if (allscriptTableOfAllergies) {
    const memberId = parseInt(allscriptTableOfAllergies.dataset.memberId);
    render(AllscriptTableOfAllergies, '#allscript_table_of_allergies', { memberId });

    const dispatchFetchEmrPatientMirthAllergiesInitialData = () => {
      store.dispatch(fetchEmrPatientMirthAllergiesInitialData({ memberId }));
    };

    set(
      window,
      'td.emr.components.admin.fetchEmrPatientMirthAllergiesInitialData',
      dispatchFetchEmrPatientMirthAllergiesInitialData
    );
  }

  const allscriptIdRowForWaitingRoom = document.querySelector('#allscript_id_row_for_waiting_room');
  if (allscriptIdRowForWaitingRoom) {
    const memberId = parseInt(allscriptIdRowForWaitingRoom.dataset.memberId);

    if (window.allscript_api_enabled_active) {
      render(AllscriptIdRowForWaitingRoom, '#allscript_id_row_for_waiting_room', { memberId });
    }
  }

  const allscriptIdRowForMemberAccount = document.querySelector('#allscript_id_row_for_member_account');
  if (allscriptIdRowForMemberAccount) {
    const memberId = parseInt(allscriptIdRowForMemberAccount.dataset.memberId);

    if (window.allscript_api_enabled_active) {
      render(AllscriptIdRowForMemberAccount, '#allscript_id_row_for_member_account', { memberId });
    }
  }

  if (window.FEATURE_TOGGLES.elation_api_enabled) {
    const elationIdRow = document.querySelector('#elation_id_row');
    if (elationIdRow) {
      const memberId = parseInt(elationIdRow.dataset.memberId);
      render(ElationIdRow, '#elation_id_row', { memberId });

      store.dispatch(fetchEmrPatientDataStart());
      store.dispatch(fetchEmrPatientInitialData({ memberId }));

      set(window, 'td.emr.components.admin.ElationIdRow', 'ElationIdRow');
    }
  }

  if (window.FEATURE_TOGGLES.elation_api_enabled) {
    $('.primary-care-summary-button').each((_index, button) => {
      const consultationId = $(button).data('consultationId');

      ReactDOM.render(<PrimaryCareSummaryButton consultationId={consultationId} />, button);
    });
  }

  if (document.querySelector('#react_ccda_viewer')) {
    render(CCDAViewer, '#react_ccda_viewer');
  }

  const remedyApiStatus = window.useRemedyApi;
  if ($('#consultation-dataset-wrapper').data()) {
    // Read data attributes from DOM that are passed to REACT components
    const {
      pharmacy = {},
      consultation: {
        consultation_id: consultationId,
        consultation_state: stateCode,
        specialty_name: consultSpecialtyName,
        pharmacy_state_unrestricted: pharmacyStateUnrestricted,
        extended_pharmacy_state_search: extendedPharmacyStateSearch,
        is_global: isGlobal,
        country_code: countryCode,
        status_code: statusCode,
        resend_fax_count: resendFaxCount,
        workflow_queue_details: workflowQueueDetails,
        phone_number: phoneNumber,
        hide_erx_audit: hideErxAudit
      },
      member: {
        member_id: memberId,
        member_dob: memberDoB,
        erx_patient_id: erxPatientId,
        member_name: memberName,
        gender: memberGender,
        address: memberAddress,
        height: memberHeight,
        weight: memberWeight
      },
      provider: {
        provider_dea: providerDEA,
        provider_npi: providerNPI,
        provider_can_prescribe: providerCanRx,
        license: providerLicense,
        can_do_cancel_rx: canDoCancelRx,
        provider_first_nm: firstNm,
        provider_last_nm: lastNm,
        provider_name: providerName,
        provider_name_with_credentials: providerNameWithCredentials,
        provider_address: providerAddress,
        eligible_for_med_history: eligibleForMedHistory,
        provider_id: providerId
      }
    } = $('#consultation-dataset-wrapper').data();

    const {
      state,
      license,
      expiration_date: expirationDate,
      valid_for_erx: validForErx,
      erx_user_id: erxUserId,
      erx_user_token: erxUserToken
    } = providerLicense || {};

    const authorizationToken = $('meta[name=csrf-token]').attr('content');

    const memberParams = {
      consultationId,
      memberId,
      memberDoB,
      stateCode,
      erxPatientId,
      memberName,
      memberGender,
      memberAddress,
      memberHeight,
      memberWeight
    };

    let pharmacyPhoneInfo = {};
    if (pharmacy.phone) {
      pharmacyPhoneInfo = {
        countryCd: pharmacy.phone.country_cd,
        areaCode: pharmacy.phone.area_code,
        phoneNumber: pharmacy.phone.phone_number
      };
    }

    const pharmacyParams = {
      pharmacyNm: pharmacy.pharmacy_nm,
      addressLine1: pharmacy.address_line1,
      phone: pharmacyPhoneInfo
    };

    const consultationParams = {
      memberId,
      memberName,
      consultationId,
      remedyApiStatus,
      consultSpecialtyName,
      stateCode,
      authorizationToken,
      pharmacyStateUnrestricted,
      extendedPharmacyStateSearch,
      isGlobal,
      advisoryPrescriptionAdminPath,
      countryCode,
      statusCode,
      resendFaxCount,
      workflowQueueDetails,
      phoneNumber,
      hideErxAudit
    };

    const providerParams = {
      consultationId,
      providerDEA,
      providerNPI,
      providerCanRx,
      license,
      expirationDate,
      state,
      validForErx,
      erxUserId,
      erxUserToken,
      canDoCancelRx,
      firstNm,
      lastNm,
      providerName,
      providerNameWithCredentials,
      providerAddress,
      eligibleForMedHistory,
      providerId
    };

    store.dispatch(updateQuickRxParams({ canSave: false, canDelete: false }));
    store.dispatch(fetchQuickRxByProvider({ consultationId }));
    store.dispatch(updateDrugSearchAvailability(!!remedyApiStatus));
    store.dispatch(updateConsultationParams(consultationParams));
    store.dispatch(updateProviderParams(providerParams));
    store.dispatch(updateMemberParams(memberParams));
    store.dispatch(updatePatientSyncStatus(erxPatientId));
    store.dispatch(updatePharmacyParams(pharmacy));

    store.subscribe(() => notificationListener(store.getState().notifications.current));

    // Set erx_patient_id for existing coffeescritps code
    // https://github.com/Teladoc/teladoc_framework/blob/master/app/assets/javascripts/shared/prescriptions.js.coffee#L294
    window.erx_patient_id = erxPatientId;

    $('#medication-table').hide();
    $('#medications_table').hide();
    $('#medications_table').next('a.add.erx_enabled').hide();

    render(ClinicalMedication, '#td-medication-history', { memberParams });
    render(ClinicalMedication, '#react_teladoc_reported_medication', {
      memberParams
    });

    render(MedicationHistory, '#vendor-med-history', {
      memberId,
      consultationId,
      providerParams,
      state: stateCode
    });

    if (countryCode !== 'CAN') {
      render(MedicationHistory, '#react_surescript_reported_medication', {
        memberId,
        consultationId,
        providerParams,
        state: stateCode
      });
    }

    render(Benefits, '#react-benefits-information');

    if (providerCanRx) {
      render(PrescriptionModal, '#react_prescription_container', {
        providerParams,
        memberParams,
        consultationParams
      });
    }

    // Workflow Queue page (not consultation)
    render(ProviderOrder, '#react_provider_orders_table', {
      consultationParams,
      providerParams,
      memberParams,
      pharmacyParams,
      detailed: true,
      isAdmin: true,
      showActions: true
    });

    render(ClinicalAllergy, '#react__clinical-allergy-container', { memberId });

    if (countryCode === 'CAN') {
      const client = getClientInstance();

      if (document.querySelector('#react_workflow_pharmacy')) {
        ReactDOM.render(
          <ApolloProvider client={client}>
            <CanadaPharmacyContainer
              consultationId={consultationId}
              memberParams={memberParams}
              consultationParams={consultationParams}
              providerParams={providerParams}
              pharmacy={pharmacy}
              client={client}
              showChangeLink
            />
          </ApolloProvider>,
          $('#react_workflow_pharmacy').get(0)
        );
      }

      if (document.querySelector('#react_ca_prescription_container')) {
        if (window.FEATURE_TOGGLES.uniform_erx_builder) {
          render(ProviderOrder, '#react_ca_prescription_container', {
            consultationParams,
            providerParams,
            memberParams,
            pharmacyParams,
            detailed: true,
            isAdmin: true,
            showActions: false
          });
        } else {
          ReactDOM.render(
            <Provider store={store}>
              <ApolloProvider client={client}>
                <CompletedConsultationProviderOrder
                  consultationId={consultationId}
                  consultationParams={consultationParams}
                  client={client}
                />
              </ApolloProvider>
            </Provider>,
            $('#react_ca_prescription_container').get(0)
          );
        }
      }
    }

    render(Recordings, '#pso_recordings', {
      consultationId
    });

    if ($('#react_current_user_id').data('id')) {
      // TODO move this to a graphql call or at least handle it if there's no id somehow
      const adminId = $('#react_current_user_id').data('id');
      render(EhrFileUploadsContainer, '#react__ehr-file-uploads-container', {
        memberId,
        consultationId,
        adminId,
        memberName
      });
    }
  }

  const providerSignatureUploadData = $('#react_provider_signature_file_uploads_container').data();

  if (providerSignatureUploadData) {
    const { providerId, providerName } = providerSignatureUploadData;

    render(ProviderSignatureFileUploadsContainer, '#react_provider_signature_file_uploads_container', {
      providerId,
      providerName
    });
  }

  render(ProviderReferral, '#new_referral_container', {
    memberId: $('#new_referral_container').data('member_id'),
    memberName: $('#new_referral_container').data('member_name'),
    memberDob: $('#new_referral_container').data('member_dob')
  });

  render(RteTestComponent, '#rte_test_container', {
    payers: $('#rte_test_container').data('payers')
  });

  render(ProviderCoverageTable, '#provider_coverage_container', {
    providers: $('#provider_coverage_container').data('providers'),
    showPreferredProvidersFilter: $('#provider_coverage_container').data('showPreferredProvidersFilter'),
    showCqsStatus: $('#provider_coverage_container').data('showCqsStatus'),
    showCqsOnShift: $('#provider_coverage_container').data('showCqsOnShift'),
    specialtyCd: $('#provider_coverage_container').data('specialtyCd')
  });

  render(ProviderSearchForm, '#provider-search-form-elastic');

  render(ProviderMatchingCriteria, '#provider-matching-criteria', {
    provider: $('#provider-matching-criteria').data('provider')
  });

  render(Inbox, '#active_conversations_container');

  render(Inbox, '#emergency-container', {
    emergencyAssistance: true,
    containerId: 'emergency-container'
  });

  render(Inbox, '#member-profile-emergency-container', {
    emergencyAssistance: true,
    containerId: 'member-support-global-styles'
  });

  const autoDialerContainer = document.querySelector('#react_auto_dialer_widget_container');
  if (autoDialerContainer) {
    const autodialParams = mapKeysDeep(JSON.parse(autoDialerContainer.dataset.autodial_params), transformKey);

    render(AutoDialerInitializer, '#react_auto_dialer_widget_container', {
      ...autodialParams
    });
  }

  const videoWidgetContainer = $('#react_video_widget_container');
  const videoParams = videoWidgetContainer.data('videoParams');
  const memberName = videoWidgetContainer.data('memberName');
  const memberId = videoWidgetContainer.data('memberId');
  const consultId = videoWidgetContainer.data('consultation-id');
  const onVideoExpanded = isExpanded => {
    document.querySelector('body').toggleClass('video_expanded', isExpanded);
  };
  const canAutoCall = videoWidgetContainer.data('canAutoCall');
  const roleCd = videoWidgetContainer.data('roleCd');
  const currentUserId = videoWidgetContainer.data('currentUserId');
  const consultation = mapKeysDeep(videoWidgetContainer.data('consultation'), transformKey);
  render(VideoContainer, '#react_video_widget_container', {
    videoParams,
    consultId,
    onVideoExpanded,
    canAutoCall,
    roleCd,
    currentUserId,
    remedyApiStatus,
    memberName,
    memberId,
    consultation
  });

  // Video Test
  const el = $('#video-test-container');
  const androidAppLink = el.data('android-app-link');
  const brandName = el.data('brand-name');
  const iosAppLink = el.data('ios-app-link');
  const tollfreeNumber = el.data('toll-free-number');
  const videoFailureMessage = el.data('video-failure-message');

  render(VideoTestContainer, '#video-test-container', {
    androidAppLink,
    brandName,
    iosAppLink,
    tollfreeNumber,
    videoFailureMessage
  });

  const notificationsElement = document.getElementById('notifications');
  const notificationsParticipantType = notificationsElement ? notificationsElement.getAttribute('data-participant-type') : null;
  const notificationsParticipantId = notificationsElement ? notificationsElement.getAttribute('data-participant-id') : null;

  render(BrowserNotifications, '#notifications', {
    headers: { Authorization: authToken.get() },
    hostUrl: window.SCREENFLOW_HOST,
    pubnubEnabled: window.FEATURE_TOGGLES.pubnub_live_chat,
    pubnubSubscribeKey: window.PUBNUB_SUBSCRIBE_KEY,
    withCredentials: true,
    withWebSdk: false,
    participantType: notificationsParticipantType,
    participantId: notificationsParticipantId
  });

  const notificationPreferencesElement = document.getElementById('notification_preferences');
  const preferencesParticipantType = notificationPreferencesElement ? notificationPreferencesElement.getAttribute('data-participant-type') : null;
  const preferencesParticipantId = notificationPreferencesElement ? notificationPreferencesElement.getAttribute('data-participant-id') : null;

  render(PreferencePage, '#notification_preferences', {
    headers: { Authorization: authToken.get() },
    pubnubEnabled: window.FEATURE_TOGGLES.pubnub_live_chat,
    pubnubSubscribeKey: window.PUBNUB_SUBSCRIBE_KEY,
    hostUrl: window.SCREENFLOW_HOST,
    withCredentials: true,
    withWebSdk: false,
    participantType: preferencesParticipantType,
    participantId: preferencesParticipantId
  });

  $('.react_consult_queue_pager').each((_, pager) => {
    const pagerId = `#${$(pager).attr('id')}`;
    const { totalEntries, page, perPage, pageParamPrefix } = $(pager).data();

    render(ConsultQueuePagerContainer, pagerId, { totalEntries, page, perPage, pageParamPrefix });
  });

  $('.reconcile_medication').click(e => {
    const container = document.createElement('div');
    document.getElementById('main_content').appendChild(container);
    const targetData = $(e.target).data();

    const closeModal = () => {
      ReactDOM.unmountComponentAtNode(container);
    };

    const onUpdateMedication = (newMedication, directions) => {
      const medicationToAdd = {
        drug_nm:              newMedication.name,
        drug_nm_confirmation: newMedication.name,
        drug_cd:              newMedication.code,
        drug_type_cd:         newMedication.code_type,
        drug_frequency:       directions,
        actively_taking_flg:  'Y'
      };
      window.addReconciledMedication(medicationToAdd, e, targetData);
      closeModal();
    };

    const onArchiveMedication = medication => {
      window.archiveMedication(medication, e);
      closeModal();
    };

    const props = {
      drugName:      targetData.drug_name,
      drugFrequency: targetData.drug_frequency,
      drugQuantity:  targetData.drug_quantity,
      onClose:       closeModal,
      onUpdateMedication,
      onArchiveMedication,
      show:          true
    };

    ReactDOM.render(
      (
        <Provider store={store}>
          <ApolloProvider client={getClientInstance()}>
            <ReviewMedicationModal {...props} />
          </ApolloProvider>
        </Provider>
      ),
      container
    );
  });

  if ($('#consultation_nurse_notes').length > 0) {
    const props = mapKeysDeep($('#consultation_nurse_notes').data('props'), transformKey);
    render(NurseNotes, '#consultation_nurse_notes', props);
  }

  const reactCarePlanNewElement = document.getElementById('react_care_plan_new');
  if (reactCarePlanNewElement) {
    render(CarePlanNew, `#${reactCarePlanNewElement.id}`, reactCarePlanNewElement.dataset);
  }

  const reactCarePlanEditElement = document.getElementById('react_care_plan_edit');
  if (reactCarePlanEditElement) {
    render(CarePlanEdit, `#${reactCarePlanEditElement.id}`, reactCarePlanEditElement.dataset);
  }

  const reactCarePlanShowElement = document.getElementById('react_care_plan_show');
  if (reactCarePlanShowElement) {
    render(CarePlanShow, `#${reactCarePlanShowElement.id}`, reactCarePlanShowElement.dataset);
  }

  const panelsContainer = document.getElementById('panels-container');
  if (panelsContainer) {
    const {actions, templates, ...patientPanelPayload} = JSON.parse(panelsContainer.dataset.patientPanel);
    render(PanelsContainer, `#${panelsContainer.id}`, {
      specialties: JSON.parse(panelsContainer.dataset.specialties),
      patientPanel: { ...mapKeysDeep(patientPanelPayload, transformKey), actions, templates },
      providerPanel: mapKeysDeep(JSON.parse(panelsContainer.dataset.providerPanel), transformKey),
    });
  }

  const ccmClientSettingsContainer = document.getElementById('ccm-client-settings-container');
  if (ccmClientSettingsContainer) {
    render(CCMClientSettingsContainer, `#${ccmClientSettingsContainer.id}`, {
      defaultClientCode: ccmClientSettingsContainer.getAttribute('default-client-code')
    });
  }

  const reactProvidersScheduleElement = document.getElementById('react_providers_schedule');
  if (reactProvidersScheduleElement) {
    render(ProvidersSchedule, `#${reactProvidersScheduleElement.id}`, {
      currentUser: mapKeysDeep(JSON.parse(reactProvidersScheduleElement.getAttribute('current-user')), transformKey),
      specialtySelectOptions: JSON.parse(reactProvidersScheduleElement.getAttribute('specialty-select-options')),
      visitReasons: mapKeysDeep(JSON.parse(reactProvidersScheduleElement.getAttribute('visit-reasons')), transformKey),
      preIntakeStatuses: mapKeysDeep(
        JSON.parse(reactProvidersScheduleElement.getAttribute('pre-intake-statuses')),
        transformKey
      ),
      refPrimaryProviderRoles: mapKeysDeep(
        JSON.parse(reactProvidersScheduleElement.getAttribute('ref-primary-provider-roles')),
        transformKey
      ),
    });
  }

  const patientConsentForMedicalRecordsExchange = document.querySelector(
    '#patient_consent_for_medical_records_exchange'
  );
  if (patientConsentForMedicalRecordsExchange) {
    const memberId = parseInt(patientConsentForMedicalRecordsExchange.dataset.memberId);

    render(PatientConsentForMedicalRecordsExchange, '#patient_consent_for_medical_records_exchange', { memberId });
  }

  const sendMhdAndPcaToSunriseActionItems = document.querySelectorAll('#send_mhd_and_pca_to_sunrise_action_item');

  $(sendMhdAndPcaToSunriseActionItems).each((_index, item) => {
    const consultationId = parseInt($(item).data('consultationId'));

    if (isNaN(consultationId)) return;

    ReactDOM.render(
      <ApolloProviderNew client={getClientInstance()}>
        <SendMhdAndPcaToSunriseEhr consultationId={consultationId} />
      </ApolloProviderNew>,
      item
    );
  });

  renderReschedule();

  const container = document.querySelector('#notification_preferences_widget');
  if (container) {
    const actor = JSON.parse(container.dataset.actor);
    render(NotificationPreferences, '#notification_preferences_widget', { actor });
  }

  if ($('#assignment_form')) {
    const props = {
      workflowQueueId: $('#assignment_form').data('workflow-queue-id'),
      canUpdate: Boolean($('#assignment_form').data('can-update'))
    };

    render(TicketAssignment, '#assignment_form', props);
  }

  if ($('#react-wfq-count-warning-icon')) {
    render(RelatedTicketsWarningIcon, '#react-wfq-count-warning-icon');
  }

  const ehrManager = document.querySelector('.ehr_section_manager');
  if (ehrManager) {
    const props = {
      memberId: parseInt(ehrManager.dataset.memberId),
      consultationId: parseInt(ehrManager.dataset.consultationId)
    };
    render(EHR, '.ehr_section_manager', props);
  }

  if ($('#react-provider-basic-search')) {
    render(ProviderBasicSearchIndex, '#react-provider-basic-search', {
      showOnShift: $('#react-provider-basic-search').data('showOnShift')
    });
  }

  if ($('#search-practice-team')) {
    render(PracticeTeamSearch, '#search-practice-team');
  }

  if ($('#new-practice-team')) {
    render(PracticeTeamNew, '#new-practice-team');
  }

  const editPracticeTeam = document.querySelector('#edit-practice-team');
  if (editPracticeTeam) {
    render(PracticeTeamEdit, '#edit-practice-team', editPracticeTeam.dataset);
  }

  const showPracticeTeam = document.querySelector('#show-practice-team');
  if (showPracticeTeam) {
    render(PracticeTeamShow, '#show-practice-team', showPracticeTeam.dataset);
  }

  render(RulesRouting, '#react-routing-rules', {
    ruleEditActive: $('#react-routing-rules').data('rule-edit-active')
  });

  render(GroupRule, '#react-rule-to-group-section', {
    groupId: $('#react-rule-to-group-section').data('group-id'),
    groupRuleCode: $('#react-rule-to-group-section').data('group-rule-code'),
    allowEditRuleCode: $('#react-rule-to-group-section').data('allow-edit-rule-code')
  });

  render(MedicationFormulariesSearch, '#medication-formularies-search');

  render(MedicationFormulariesDetails, '#medication-formularies-details', {
    drugId: $('#medication-formularies-details').data('drug-id')
  });

  if ($('#react-same-day-visit').length > 0 ) {
    const props = {
      providerId: $('#react-same-day-visit').data().providerId
    };

    render(SameDayVisits, '#react-same-day-visit', props);
  }

  const supervisingPhysicians = document.querySelector('#np_coordination');
  if (supervisingPhysicians) {
    render(SupervisingPhysicians, '#np_coordination')
  }

  if (document.querySelector('#sku-calculator')) {
    render(SkuCalculator, '#sku-calculator');
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service_worker.js').then(
      function (registration) {
        console.log('Service worker registration succeeded');
      },
      /*catch*/ function (error) {
        console.log('Service worker registration failed:', error);
      }
    );

    initNotifications()
      .then(notifyBrowser => {
        window.showNotification = notifyBrowser;
        document.addEventListener('messaging:new_toast', ev => {
          const text = 'You attention is requested on admin app';
          const title = 'Notification';
          let icon = undefined;
          try {
            icon = document.querySelector(`meta[property='staticData:square-logo-url']`).getAttribute('content');
          } catch (e) {}
          showNotification(title, text, { icon });
        });

        const channel = new BroadcastChannel('timer-channel');
        let timer;
        channel.onmessage = event => {
          if (event.data && event.data.type === 'RESET_TIMEOUT' && window.location.pathname !== '/signin') {
            console.log('resetting timer', moment());
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
            timer = setTimeout(
              () =>
                showNotification(
                  'Attention',
                  'Your session will expire soon. Please select the option below to prolong.',
                  { actions: [{ action: 'call_heartbeat', title: 'Stay signed in' }] }
                ).then(() => axios.get('/screenflow')),
              1500000
            ); // 25min in ms
          }
        };
      })
      .catch(e => {
        // if user denies permission, we will get rejection w/ undefined. we
        // don't really care about that since it's part of normal flow, just
        // swallow it.
        // if we do get some sort of error, it may be legit, at least log it
        if (e) {
          console.error('initNotifications rejected', e);
        }
      });

    const channel = new BroadcastChannel('timer-channel');
    let timer;
    channel.onmessage = event => {
      if (event.data && event.data.type === 'RESET_TIMEOUT' && window.location.pathname !== '/signin') {
        console.log('resetting timer', moment());
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        timer = setTimeout(
          () =>
            showNotification('Attention', 'Your session will expire soon. Please select the option below to prolong.', {
              actions: [{ action: 'call_heartbeat', title: 'Stay signed in' }]
            }).then(() => axios.get('/screenflow')),
          1500000
        ); // 25min in ms
      }
    };
  }

  const careTeamTasksContainer = document.getElementById('care_team_tasks_container');
  if (careTeamTasksContainer) {
    render(CareTeamTasks, `#${careTeamTasksContainer.id}`, {
      types: JSON.parse(careTeamTasksContainer.dataset.types),
      categories: JSON.parse(careTeamTasksContainer.dataset.categories),
      currentUser: JSON.parse(careTeamTasksContainer.dataset.currentUser),
      defaultView: mapKeysDeep(JSON.parse(careTeamTasksContainer.dataset.defaultView), transformKey),
      templates: JSON.parse(careTeamTasksContainer.dataset.templates),
      suggestions: JSON.parse(careTeamTasksContainer.dataset.suggestions)
    });
  }

  const serviceLineContainer = document.getElementById('service-line-filter');
  if (serviceLineContainer) {
    const serviceOptions = JSON.parse(serviceLineContainer.getAttribute('data-service-options'));
    render(ServiceLine,`#${serviceLineContainer.id}`, {serviceOptions});
  }
});

window.renderProviderIncentiveCost = (selector, props) => {
  render(ProviderIncentiveCost, selector, props);
};

window.renderProviderSurgeIncentiveCost = selector => {
  render(ProviderSurgeIncentive, selector);
};

window.renderConsultQueueFiltersContainer = (selector, props) => {
  render(ConsultQueueFiltersContainer, selector, props);
};

window.renderEditPayer = (selector, props) => {
  render(EditPayer, selector, props);
};

window.renderViewPayer = (selector, props) => {
  render(EditPayer, selector, props);
};

window.renderSamlConfig = (selector, props) => {
  render(EditSamlConfig, selector, props);
};

window.renderEgrIndex = (selector, props) => {
  render(EgrIndex, selector, props);
};

window.renderMultiContractOrgRelationsIndex = (selector, props) => {
  render(MultiContractOrgRelationsIndex, selector, props);
};

window.renderSurescriptsInformation = (selector, props) => {
  render(SurescriptsInformationContainer, selector, props);
};

window.renderClinicalReferralsIndex = (selector, props) => {
  render(ClinicalReferralsIndex, selector, props);
}

window.renderInsuranceNetworkContainer = (selector, props) => {
  render(InsuranceNetworkContainer, selector, props);
};

window.renderLabOrderHistoryModal = (event) => {
  const container = document.createElement('div');
  document.getElementById('main_content').appendChild(container);
  const closeModal = () => {
    ReactDOM.unmountComponentAtNode(container);
  };
  const props = { ...$(event.target).data(), closeModal };

  ReactDOM.render(<LabOrderHistoryModal {...props} />, container);
}

window.renderVendorSolutionTool = (selector, props) => {
  render(VendorSolutionTool, selector, props)
}

window.renderVendorSolutionSetting = (selector, props) => {
  render(VendorSolutionSetting, selector, props)
}

const api = new Api({
  unlockAccount,
  onSearch: findMembers,
  onRteCheck: params => performRteCheck(params, sharedClientInstance),
  fetchGroups,
  loadProfile: (memberId, groupId) => loadProfile(memberId, groupId, sharedClientInstance),
  openProfile,
  requestAVisit,
  visitResetPassword,
  updateBillingInformation,
  launchSecurePay,
  updateMhd,
  resetPassword,
  impersonate,
  escalateMember,
  fetchPayerList: fetchPayers,
  startRegistration: params => {
    return openReg(params, featureActive('searchBeta'));
  },
  memberProfilePath,
  issueDiscount,
  issueFreeConsultation,
  viewVisits,
  terminateBenefit,
  deleteOffer,
  cancelAccount,
  reactivateAccount,
  openReferrals,
  downloadCCR,
  requestCCR,
  addDependent,
  authorizeExcuseNote,
  openInvoiceHistory,
  problemPatient,
  sendMessage,
  createNote,
  draftCarePlan,
  editCarePlan,
  deleteCarePlan,
  createCarePlan,
  disassociateProvider,
  acceptCareRecipient,
  addCareRecipient,
  rejectCareRecipient,
  deleteCareRecipient,
  addCaregiver,
  deleteCaregiver,
  openGroup,
  I18n,
  translate,
  canDisplayInitiateReferralButton,
  fetchSpecialtiesForInitiateReferral,
  fetchDataForRecentConsultationsTable,
  sendReferral,
  internalReferrals: memberId => getInternalReferrals(memberId),
  enableCareHubInternalReferrals: () => {
    return featureActive('enableCareHubInternalReferrals');
  },
  healthSignals: memberId => getHealthSignals(memberId, sharedClientInstance),
  enableCareHubHealthSignals: () => {
    return featureActive('enableCareHubHealthSignals');
  },
  errorLogger: (keyWord, error) => {
    return console.log(error)
  },
  labVendors: memberId => getLabVendors(memberId, sharedClientInstance),
  createPreferredLabVendor: (memberId, vendorId) => createPreferredLabVendor(memberId, vendorId, sharedClientInstance),
  vendorPoints: memberId => getVendorPoints(memberId, sharedClientInstance),
  openConsultation,
  openInvoicePdf,
  editPrimaryInsuranceInfo: (memberId, primaryInsuranceOptions, groupId) => editPrimaryInsuranceInfo(memberId, primaryInsuranceOptions, groupId, sharedClientInstance),
  editSecondaryInsuranceInfo: (memberId, secondaryInsuranceOptions) => editSecondaryInsuranceInfo(memberId, secondaryInsuranceOptions, sharedClientInstance),
  getRtePayers: () => getRtePayers(sharedClientInstance),
  renderVisitsPage,
  queueLinkBenefits,
  validateLinkBenefits,
  benefitStatusManager,
  validateQuarantineAction,
});

const MemberSupportProvider = function (props) {
  return (
    <MemberSupportContext.Provider
      value={{
        api,
        countries: JSON.parse(document.querySelector("meta[property='staticData:countries']").getAttribute('content')),
        states: JSON.parse(document.querySelector("meta[property='staticData:states']").getAttribute('content')),
        locale: document.querySelector('html').getAttribute('lang'),
        elasticsearchDisabled:
          document.querySelector("meta[property='featureToggles:searchBeta']").getAttribute('content') !== 'true',
        degradedSearch: document.querySelector("meta[property='featureToggles:degradedSearch']").getAttribute('content')
      }}
    >
      {props.children}
    </MemberSupportContext.Provider>
  );
};

window.renderComponent = (ComponentClass, renderTarget, props) => {
  ReactDOM.render(
    <MemberSupportProvider>
      <ComponentClass {...props} />
    </MemberSupportProvider>,
    document.querySelector(renderTarget)
  );
};

window.renderComponentInteractingWithLegacy = ({ domNode, componentName, props = {} }) => {
  const Component = window.reactComponents[componentName];

  ReactDOM.render(<Component {...props} />, domNode);
};
